import { useEffect, useReducer, useState } from "react";

// Varias pantallas abren su propio LoadingDhn mientras la carga global sigue
// visible; solo el primero abierto se dibuja para no apilar fondos oscuros.
let openLoadingIds = [];
let nextLoadingId = 0;
const listeners = new Set();

const notifyListeners = () => listeners.forEach((listener) => listener());

export default function useLoadingOwner(isOpen) {
  const [loadingId] = useState(() => {
    nextLoadingId += 1;
    return nextLoadingId;
  });
  const [, forceRender] = useReducer((count) => count + 1, 0);

  useEffect(() => {
    listeners.add(forceRender);
    return () => listeners.delete(forceRender);
  }, []);

  useEffect(() => {
    if (!isOpen) return undefined;

    openLoadingIds = [...openLoadingIds, loadingId];
    notifyListeners();

    return () => {
      openLoadingIds = openLoadingIds.filter((id) => id !== loadingId);
      notifyListeners();
    };
  }, [isOpen, loadingId]);

  return (
    Boolean(isOpen) &&
    (!openLoadingIds.length || openLoadingIds[0] === loadingId)
  );
}
